import React, { Component } from "react";
import { Field } from "formik";
import ColorField from "../fields/ColorField";
import CheckField from "../fields/CheckField";
import { connect } from "react-redux";
import { Picker, Wrapper } from "../../theme/styled";
import { injectIntl } from "react-intl";

class FieldsVolleyball extends Component {
  render() {
    const { field, intl } = this.props;
    const { volleyballLines } = field.options;
    return (
      <Wrapper>
        <Field
          name="volleyballLines"
          component={CheckField}
          label={intl.formatMessage({
            id: "raquet.volleyballLines",
            defaultMessage: "Linie do siatkówki",
          })}
        />
        {volleyballLines ? (
          <Picker>
            <Field
              name="volleyballColor"
              component={ColorField}
              label="Kolor Lini"
            />
          </Picker>
        ) : null}
      </Wrapper>
    );
  }
}

const mapState = ({ field }) => ({ field });
FieldsVolleyball = connect(mapState)(FieldsVolleyball);
export default injectIntl(FieldsVolleyball);
